import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import withLocation from "../../withLocation";
import Service from '../service/Service';
import './Expert.css';


const service = new Service();

class ExpertListing extends Component {
    constructor(props) {
        super(props);
        let initialData = {};
        let serverSideData = {};


        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];

            console.log("serverSideData ===>", serverSideData)

            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }

        this.state = {
            experts: serverSideData?.expertData || [],  
            pageTitle: serverSideData?.expPageTitle || "",
            pageDescription: serverSideData?.expPageDes || "",
            error: null
        };

    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "getExpertListdata_v1";
        let body = JSON.stringify({
            "pagesize": 100,
            "pageno": 1
        })

        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        const { location } = this.props;
        const queryParams = new URLSearchParams(location.search);
        const category = queryParams.get('category') || 'all';

        
    }

    detailPage = (data) => {

        console.log("Navigating to expert detail page with data:", data);
    }

    handleProfile = (expert) => {
        const expertNameSlug = expert.name
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '') // remove special chars
            .trim()  
            .replace(/\s+/g, '-'); // replace spaces with hyphens

        const categorySlug = (expert.occupation).toLowerCase().replace(/\s+/g, '-');

        const url = `/experts/${categorySlug}/${expertNameSlug}/${expert.user_id}`;
        console.log("Navigating to URL:", url);
        // window.location.href = service.getRedirectUrl(url);
        window.open(service.getRedirectUrl(url), '_blank', 'noopener,noreferrer');
    };

    gotoExpShare =(url)=>{
        if (url) {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    }

    render() {
        const { experts } = this.state;

        return (
            <main className="main-container">
                <Helmet>
                    <title>Expert Panel - FirstCry Parenting</title>
                    <meta name="description" content="Browse our list of experts in various fields." />
                </Helmet>
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Expert Panel</span>
                    </div>
                    <h1 className="B24_00">Expert Panel</h1>
                </div>
               
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="my_account expert_panel_main">
    
                            <div className="expert_detail">
                                <div className="expert_detail_title M18_fc88af">
                                    Meet our Firstcry Experts
                                </div>
                                <div className="expert_detail_content R16_42">
                                    We believe in delivering the best and the most reliable content. To ensure this, we bring together a diverse team where each specialist reviews or writes medical content only in their field of expertise.
                                </div>
                            </div>

                            {/* Expert List */}
                            <div className="menu_content">
                                <div id="paediatrician">
                                   
                                    {Object.keys(experts).map((category) => (
                                        <div key={category}>
                                            <div className="expert_type">
                                                <span>{category} Panel</span>
                                            </div>

                                            {experts[category].map((expert) => (
                                                <div className="experts" key={expert.user_id}>
                                                    <div onClick={() => this.handleProfile(expert)}>
                                                        <div className="expert_panel">
                                                            <div className="expert-info-container" data-name={expert.name}>

                                                                <span className="expert_img lft">
                                                                    <img
                                                                        src={expert.profile_pic}
                                                                        alt={expert.name}
                                                                        title={expert.name}
                                                                        onError={(e) =>
                                                                            e.target.src = "https://cdn.cdnparenting.com/brainbees/community/Images_folder/default-img.png"
                                                                        }
                                                                    />
                                                                </span>

                                                                <span className="expert">
                                                                    <span className="name M14_42">
                                                                        {expert.name}
                                                                    </span>

                                                                    <span className="spltn R14_61">
                                                                        {expert.education_qualification}
                                                                    </span>

                                                                    <span className="exp expert_experience L12_61">
                                                                        {expert.experience || "Not Specified"}
                                                                    </span>

                                                                    <span className="social-container">
                                                                        {expert.social && expert.social.length > 0 &&
                                                                            expert.social.map((social, index) => (
                                                                            <span className="social-media exp-share" key={index}>
                                                                                <a className="exp-share" onClick={(e) => {
                                                                                    e.stopPropagation(); 
                                                                                    this.gotoExpShare(social.redirectionUrl);
                                                                                }} rel="noopener noreferrer nofollow"
                                                                                >
                                                                                <img className="exp-share" src={social.imageIconUrl} alt={social.name}
                                                                                    onError={(e) => (e.target.src = "https://cdn.cdnparenting.com/brainbees/community/Images_folder/default-img.png") }
                                                                                />
                                                                                </a>
                                                                            </span>
                                                                        ))}
                                                                    </span>

                                                                </span>

                                                                <div className="hospital" id={`hos_${expert.user_id}`}>
                                                                    
                                                                    <div className="hospital-photo">
                                                                        {expert.hospital_image_url !="" &&
                                                                        <img 
                                                                            src={expert.hospital_image_url}
                                                                            alt={expert.hospital_name}
                                                                            title={expert.hospital_name}
                                                                        />
                                                                        }
                                                                    </div>
                                                                    

                                                                    <div className="name_container ">
                                                                        <span className="hospital_name R13_9e">
                                                                            {expert.hospital_name}
                                                                        </span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}

                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <Right url={this.props.location.pathname} />
                
            </main>
        );
    }
}

export default withLocation (ExpertListing);